module.exports = __webpack_public_path__ + "img/BH.8f0a6f72.svg";